import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import { ModalButtonSave, ModalButtonUpdate, } from '../../constant';
import { DeleteMicContainer } from './DeleteMicContainer';
import { FormMicContainer } from './FormMicContainer';
import { Dialog } from 'primereact/dialog';

export const ModalMicContainers = (props) => {

    const {
        modal, modalTitle, toggle, method, loading,
        name_container, handleInputChange,
        validaciones, saveCreate, saveUpdate, saveDelete,
        closeDialog
    } = props;

    return (
        <Dialog 
            header={modalTitle}
            visible={modal}
            onHide={closeDialog}
            closable={true}
            modal
            blockScroll
            className='medium-dialog'
            maskClassName="medium-dialog-mask"
        >
            {
                method === "create"
                    ?
                    <FormMicContainer
                        button={ModalButtonSave}
                        {...{ toggle, loading, handleInputChange, methodAction: saveCreate }}
                    />
                    :
                    (method === "update")
                        ?
                        <FormMicContainer
                            button={ModalButtonUpdate}
                            {...{ toggle, loading, handleInputChange, validaciones, methodAction: saveUpdate, name_container, }}
                        />
                        :
                        <DeleteMicContainer
                            {...{ toggle, loading, name_container, saveDelete }}
                        />
            }
        </Dialog>
    )
}
